module.exports = __webpack_public_path__ + "img/whiteboard.71bd8dce.svg";